import { Task } from "./Routine/types";

export const getTaskCreateInput = (task: Task) => {
  const base = {
    id: task.id,
    title: task.title,
    instructions: task.instructions,
    imageIds: task.images.map(({ id }) => id),
  };
  return {
    check:
      task.type === "TaskCheck"
        ? {
            ...base,
            sentiments: task.sentiments,
          }
        : undefined,
    number:
      task.type === "TaskNumber"
        ? { ...base, unit: task.unit, suffix: "" }
        : undefined,
    text: task.type === "TaskText" ? base : undefined,
  };
};
